var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLavaImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 688,
    viewBox: "0 0 170 688",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_67_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.706 -112.344C239.706 -112.344 215.738 -25.1329 122.157 45.4392C49.9069 99.9246 19.278 401.339 38.7909 542.999C48.6834 611.957 106.571 669.772 147.561 712.173L83.2105 771.747L-38.1039 667.579C-25.1323 638.748 -12.6166 611.376 -3.96252 587.961C40.1796 468.531 -3.95329 259.524 -30.4384 31.5207C-34.1653 -172.347 147.225 -112.344 239.706 -112.344Z",
    fill: "#F29C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.886 -76.7886C196.886 -76.7886 31.8732 46.5754 25.6385 232.891C-57.1242 -24.0471 45.2148 -121.442 196.886 -76.7886Z",
    fill: "#FAD121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.684 -34.2898C119.684 -34.2898 35.0411 33.497 27.1735 136.323C5.30111 8.17128 48.3473 -39.9277 119.684 -34.2898Z",
    fill: "#FBDC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7794 570.421C24.7794 570.421 54.0776 658.477 100.808 702.01C112.996 713.364 122.523 721.885 130.03 728.406L83.2103 771.749L-12.3613 689.694C0.896103 655.503 18.4862 606.218 24.7794 570.421Z",
    fill: "#FAD121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5526 648.723C28.5526 648.723 41.6202 688.016 62.4671 707.437C72.8191 717.08 91.0529 734.558 106.767 749.92L83.2106 771.745L9.44864 708.42C15.3939 693.569 25.3186 667.117 28.5526 648.723Z",
    fill: "#FBDC5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_67_370",
    x: -57.1039,
    y: -120.582,
    width: 296.81,
    height: 900.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -15,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.611765 0 0 0 0 0.145098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_67_370"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_67_370",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavaImg);
export default __webpack_public_path__ + "static/media/lava-img.4ad0d6777eb37589dcbc414f51b3c9bc.svg";
export { ForwardRef as ReactComponent };